import React, { useState, useRef, useEffect } from "react";
import './CustomDropdown.scss'
import useText from "../../../../FTTX/hooks/useText";
import { NO_MATCH, SEARCH } from "../../../../FTTX/GlobalConstant";
// import "./CustomDropdown.scss"; 

const CustomDropdown = ({ options = [], placeholder = "Select...", onSelect, name, clearSelectedValue,field }) => {

  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState("");
  const dropdownRef = useRef(null);
  const { getText } = useText();

  useEffect(() => {
    setSelected('')
  }, [clearSelectedValue])

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = Array.isArray(options)
    ? options.filter((opt) =>
      opt?.value?.toLowerCase()?.includes(search?.toLowerCase() ?? '')
    )
    : [];

  const handleSelect = (value, name) => {
    setSelected(value);
    onSelect(value, name);
    setShowDropdown(false);
    setSearch("");
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  };


  return (
    <div className={field?.colunms}>
      <div className="form-group">
        <label>{field?.label} {field?.required ? <span>*</span> : ''}</label>
        <div className="dropdown-wrapper" ref={dropdownRef}>
          <div className="form-control" onClick={() => setShowDropdown((prev) => !prev)} >
            {selected?.value || placeholder}
          </div>
          {showDropdown && (
            <div className="dropdown-content show">
              <input
                type="text"
                placeholder={getText(SEARCH)}
                value={search}
                className="form-control"
                onChange={(e) => setSearch(e.target.value)}
              />

              {filteredOptions.length ? (
                <><ul>
                  {filteredOptions.map((opt, i) => (
                    <li key={i} onMouseDown={() => handleSelect(opt, name)}>
                      {opt.value}
                    </li>
                  ))}
                </ul>
                </>
              ) : (
                <div className="no-options">{getText(NO_MATCH)}</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomDropdown;
